<div *ngIf="history.length > 0; else emptyState" class="h-full overflow-y-auto py-2 max-h-[calc(100vh-9rem)]">
  <p-timeline [value]="history">
    <ng-template pTemplate="content" let-item>
      <div class="flex flex-col justify-between items-start !w-full mb-4">
        <div class="flex flex-row justify-between items-start !w-full">
          <div class="flex flex-row justify-between gap-2">
            <div class="relative w-fit flex-shrink-0">
              <!-- <img [src]="item.createdBy?.user | userAvatar" alt="User Avatar" class="w-8 h-8 rounded-full" /> -->
              @if(isUserUnverified(item.createdBy)){
              <span
                class="absolute top-3 left-2.5 w-6 h-6 flex items-center justify-center bg-gray-500 text-white rounded-full text-xs"
                [pTooltip]="'Email Unverified'">
                <i class="pi pi-exclamation-circle text-white text-sm"></i>
              </span>
              }
            </div>
            <div class="flex flex-col justify-between items-start overflow-x-auto">
              <div class="flex flex-col w-full">
                <app-user-name-display [user]="item.createdBy" [fallbackText]="'External User'"
                  [variant]="'avatar-name'">
                </app-user-name-display>
                <span [pTooltip]="isSmallScreen ? item.createdBy?.email : ''" tooltipPosition="top"
                  class="text-gray-500 text-sm">
                  {{ isSmallScreen ? (item.createdBy?.email | truncate:20) : item.createdBy?.email }}
                </span>
              </div>
              <span class="text-gray-400 text-xs">{{item.data.message}}</span>
              <span class="text-gray-600 text-xs">{{item.createdAt | dateFormatter}}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-timeline>
</div>

<ng-template #emptyState>
  <div class="flex items-center justify-center h-full w-full">
    <div class="mb-20 w-full flex flex-col items-center justify-center">
      <div class="h-[8.5rem]">
        <i [innerHTML]="SVG.EMPTY_HISTORY | sanitizeHtml" class="h-[18.5rem] w-full"></i>
      </div>
      <p class="text-sm text-gray-500 w-[14rem] text-center mt-2">
        History will be shown here once any changes are made
      </p>
    </div>
  </div>
</ng-template>